// extracted by mini-css-extract-plugin
module.exports = {"toggle":"CompareToggleButton_toggle__3nNaP","active":"CompareToggleButton_active__yU_a6"};